import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const getSelfEmploymentCreations = async () => {
  return (
    await companyCreationAxiosInstance.get(
      'v1/customer/single-member-firm-creations'
    )
  ).data;
};
